import { Capacitor } from "@capacitor/core";

// Apple rejected build 30 under guideline 5.1.1(v): "the app requires users to
// register before browsing products. Registration can only be required for
// account-based features like adding to cart or checking out."
//
// On iOS the logged-out root route therefore renders the browse feed directly,
// with no Landing splash in front of it, so a reviewer sees products on first
// launch. Android and web keep Landing and reach the same feed through an
// explicit "Browse as guest" link.
//
// Once Apple approves, flip IOS_SKIPS_LANDING to false and iOS behaves like
// everywhere else. Everything below the root route is already public
// (/items/:id, /u/:id, /buy/:handle), and cart and checkout stay gated, which
// is exactly what the guideline permits.
export const IOS_SKIPS_LANDING = true;

const GUEST_KEY = "stoop:guestBrowsing";

export function isIosNative(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
}

// Opting in writes localStorage and the caller does a full page load rather
// than a wouter navigation. The path doesn't change (both Landing and the feed
// live at "/"), and trap #13 says same-path navigation is unreliable in the
// wrapped WebView. A reload also means the flag is read once at boot instead of
// needing to be reactive state.
export function optIntoGuestBrowsing(): void {
  try {
    window.localStorage.setItem(GUEST_KEY, "1");
  } catch {
    /* private mode — the reload just lands back on Landing */
  }
}

export function showsGuestFeed(): boolean {
  if (IOS_SKIPS_LANDING && isIosNative()) return true;
  try {
    return window.localStorage.getItem(GUEST_KEY) === "1";
  } catch {
    return false;
  }
}
